<template>
  <div class="custom-form cmi-res">
    <div class="panel-body">
      <div class="panel panel-info cmi-search-header-panel">
        <div class="row cmi-search-wrapper">
          <div class="col-md-10 col-md-offset-1">
            <div class="cmi-search-header">
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Select by Alert start date</span>
                </div>
                <div class="col-md-6 header-middle">
                  <select
                    id="alt_FilterLabel"
                    name="alt_FilterLabel"
                    @change="getFormDataByLabel"
                    v-model.trim="alt_FilterLabel"
                    class="form-control"
                  >
                    <option></option>
                    <option
                      v-for="item in alertLabels"
                      v-bind:value="item.value"
                      :key="item.value"
                      >{{ item.label }}</option
                    >
                  </select>
                </div>
                <div class="col-md-2 header-right">
                  <span
                    v-if="aniLabelsLoading"
                    class="fa fa-spinner fa-spin fa-3x fa-fw"
                  ></span>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Search by Alert ID</span>
                </div>
                <div class="col-md-6 header-middle">
                  <masked-input
                    type="text"
                    name="alt_FilterCode"
                    class="form-control"
                    :mask="[
                      /[A-Z]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i
                    ]"
                    :guide="false"
                    :showMask="false"
                    :pipe="toUpperCase"
                    v-model.trim="alt_FilterCode"
                    spellcheck="false"
                  >
                  </masked-input>
                </div>
                <div class="col-md-2 cmi-search-header-btn-search">
                  <button
                    @click="getFormDataByCode"
                    v-bind:disabled="disableCriteriaMet_alt_FilterCode"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Search
                  </button>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-6 col-md-offset-3 cmi-search-header-btn-add">
                  <button
                    @click="newFormData"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Add new item
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Alert details</h3>
        </div>

        <div class="panel-body">
          <div v-if="showAlertId" class="form-group">
            <label for="alt_AlertCode">Alert ID</label>
            <div
              id="alt_AlertCode"
              name="alt_AlertCode"
              class="form-control cmi-file-label"
            >
              {{ fdata.alt_AlertCode }}
            </div>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('alt_AlertDetails') }"
          >
            <label for="alt_AlertDetails">Alert details</label>
            <textarea
              id="alt_AlertDetails"
              name="alt_AlertDetails"
              v-model.trim="fdata.alt_AlertDetails"
              v-validate.initial="{ required: true, max: 1000 }"
              maxlength="1000"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("alt_AlertDetails")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('alt_StartDate') }"
          >
            <label for="alt_StartDate">Start date and time</label>
            <input
              id="alt_StartDate"
              name="alt_StartDate"
              v-model.trim="fdata.alt_StartDate"
              v-validate.initial="{
                required: true,
                valid_date_format: { active: true }
              }"
              placeholder="DD-MMM-YYYY"
              maxlength="11"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("alt_StartDate") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('alt_EndDate') }"
          >
            <label for="alt_EndDate">End date and time</label>
            <input
              id="alt_EndDate"
              name="alt_EndDate"
              v-model.trim="fdata.alt_EndDate"
              v-validate.initial="{
                required: true,
                valid_date_format: { active: true },
                lookup_compare: {
                  opt: 'gteq',
                  targetValue: fdata.alt_StartDate,
                  dataType: 'date'
                }
              }"
              placeholder="DD-MMM-YYYY"
              maxlength="11"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("alt_EndDate") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('alt_Recurrence') }"
          >
            <label for="alt_Recurrence">Recurrence</label>
            <select
              id="alt_Recurrence"
              name="alt_Recurrence"
              v-model="fdata.alt_Recurrence"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">One time only</option>
              <option value="2">Daily</option>
              <option value="3">Weekly</option>
              <option value="4">Monthly</option>
              <option value="5">Yearly</option>
            </select>
            <span class="help-block">{{ errors.first("alt_Recurrence") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('alt_Status') }"
          >
            <label for="alt_Status">Status</label>
            <select
              id="alt_Status"
              name="alt_Status"
              v-model="fdata.alt_Status"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
              <option value="90">Delete</option>
            </select>
            <span class="help-block">{{ errors.first("alt_Status") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <modal
        name="alert-dialog-alert"
        :width="400"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>

      <div class="btn-submit-wrapper">
        <div v-if="showAnimation" class="cc-animation">
          <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
          <span>Form submission in progress</span>
        </div>
        <div class="cc-submit-btn-wrapper">
          <button
            v-on:click="saveFormData"
            v-bind:disabled="showAnimation"
            type="submit"
            class="btn btn-primary"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import VueRecaptcha from "vue-recaptcha";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  // components: {
  //   VueRecaptcha,
  // },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        pkey: 0,
        alt_AlertCode: "",
        alt_AlertDetails: "",
        alt_StartDate: "",
        alt_EndDate: "",
        alt_Recurrence: null,
        alt_Status: 1
      },
      showAnimation: false,
      subformIndex: 0,
      alertMessage: "",
      alertLabels: [],
      alt_FilterLabel: "",
      alt_FilterCode: "",
      aniLabelsLoading: false
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    saveFormData: async function() {
      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-alert");
        return;
      }

      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      let rData = null;
      let actionUrl = `${this.baseUrl}UpdateFormData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fdata, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }

      if (rData != 0) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-alert");
        return;
      }

      if (!this.fdata.pkey) {
        this.resetFormData();
      }

      this.alertMessage = "Your form has been submitted successfully";
      this.$modal.show("alert-dialog-alert", { status: 2 });
      this.showAnimation = false;
    },

    getFormDataByLabel: async function() {
      this.alt_FilterCode = "";
      if (!this.alt_FilterLabel) {
        this.resetFormData();
        return;
      }

      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pkey: this.alt_FilterLabel }
      };

      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByLabel`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = true;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
      }
      this.aniLabelsLoading = false;
    },

    getFormDataByCode: async function() {
      this.alt_FilterLabel = "";
      const alt_FilterCode = this.alt_FilterCode.replace(/\s/g, "");
      if (!alt_FilterCode) {
        this.resetFormData();
        return;
      }
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pcode: alt_FilterCode }
      };

      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByCode`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
      } else {
        this.resetFormData();
        this.alertMessage = "Item not found";
        this.$modal.show("alert-dialog-alert");
      }
      this.aniLabelsLoading = false;
    },
    getAlertLabels: async function() {
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      let rData = null;
      let actionUrl = `${this.baseUrl}GetAlertLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData != 0) {
        Object.assign(this.alertLabels, rData);
      }
      this.aniLabelsLoading = false;
    },
    toUpperCase: function(value) {
      return value.toUpperCase();
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        pkey: 0,
        alt_AlertCode: "",
        alt_AlertDetails: "",
        alt_StartDate: "",
        alt_EndDate: "",
        alt_Recurrence: null,
        alt_Status: 1
      });
    },
    newFormData: function() {
      this.resetFormData();
      this.alt_FilterLabel = "";
      this.alt_FilterCode = "";
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-alert");
    },
    beforeOpenDialog: function({ params }) {
      if (params) {
        this.alertParams = params.status;
      }
    },
    beforeCloseDialog: function() {
      if (this.alertParams == 2) {
        this.$store.commit("resetBasket");
        this.alertParams = null;
      }
    }
  },
  computed: {
    showAlertId: function() {
      if (this.fdata.alt_AlertCode) {
        return true;
      }
      return false;
    },
    disableCriteriaMet_alt_FilterCode: function() {
      if (this.alt_FilterCode && this.alt_FilterCode.length == 16) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    await this.getAlertLabels();
  }
};
</script>
